enum LoginType {
  LOGIN_PHONE_NUMBER = 'LOGIN_PHONE_NUMBER',
  LOGIN_SCA = 'LOGIN_SCA',
  LOGIN_EMAIL = 'LOGIN_EMAIL',
}

export default LoginType
